import { Line } from '@antv/g2plot';
import React, { useEffect } from 'react';
import dayjs from 'dayjs';

import { TIME } from '../../../../services/util'
import { useSelector } from 'react-redux';

const LineCharts = ({ sum }) => {

    const drivers = useSelector(state => state.containers.v3.drivers.byID)

  useEffect(() => {
    // Grouped by drvid
    const groupedByDriver = sum.reduce((acc, item) => {
      if (!acc[item.drvid]) {
        acc[item.drvid] = [];
      }
      acc[item.drvid].push({
        date: TIME.parseDate(item.reportTime),
        value: item.overallScore,
        drvid: item.drvid,
        driver: drivers[item.drvid]?.name
      });
      return acc;
    }, {});

    // Flatten 
    const newSum = Object.values(groupedByDriver).flat();


    const sortedData = (data) => {
      return data.sort((a, b) => {
        const aDate = dayjs(a.date, 'YYYY/MM/DD');
        const bDate = dayjs(b.date, 'YYYY/MM/DD');

        if (aDate.isBefore(bDate)) return -1;
        if (aDate.isAfter(bDate)) return 1;
        return 0;
      });
    };

    const chart = new Line('line-container', {
      data: sortedData(newSum),
      xField: 'date',
      yField: 'value',
      seriesField: 'driver', // This creates multiple lines
      point: {
        shape: 'circle',
        size: 4,
      },
      style: {
        lineWidth: 2,
      },
      yAxis: {
        tickCount: 1,
        tickMethod: () => [55, 65, 75, 85, 100], 
        label: { 
          formatter: (value) => {
            const num = Number(value);
            if (num === 55) return '0–55';
            if (num === 65) return '56–65';
            if (num === 75) return '66–75';
            if (num === 85) return '76–85';
            if (num === 100) return '86–100';
            return '';
          }
        }
      },
      legend: {
        position: 'top-right'
      },
      // Optional: Custom colors untuk setiap driver
    //   color: ['#1890ff', '#52c41a', '#faad14']
    });

    chart.render();

    return () => {
      chart.destroy();
    };
  }, []);

  return <div id='line-container' />;

};

export default React.memo(LineCharts);